/** @jsxRuntime classic */
/** @jsx jsx */
import { useTranslation } from 'react-i18next';
import { css, jsx } from '@emotion/react';
import { Typography as Text } from '@mui/material';

import CheckCircleIcon from '@mui/icons-material/CheckCircle';

import { useStore, TOKEN, GUEST } from '../store';
import { Navigate } from 'react-router-dom';

import Skeleton from '../components/Skeleton';
import { useIsMobile } from '../utils/hooks';

import SignupForm from '../components/login/SignupForm';
import { useParams } from 'react-router-dom';
import { IS_SINGLE_TENENT_MODE } from '../constants';

function CheckList({ t }) {
  const liCss = css`
    display: flex;
    align-items: center;
    gap: 16px;
    height: 24px;
    position: relative;
    color: #000000de;
  `;
  return (
    <ul
      css={css`
        list-style: none;
        padding-left: 0;
        margin: 0;
        display: flex;
        flex-direction: column;
        gap: 1rem;
        align-items: flex-start;
        text-wrap: nowrap;
      `}
    >
      <li css={liCss}>
        <CheckCircleIcon sx={{ color: 'success.main' }} />{' '}
        <Text variant="subtitle1" fontWeight="600" fontSize="18px">
          {t('Sveriges bästa AI-transkribering')}
        </Text>
      </li>
      <li css={liCss}>
        <CheckCircleIcon sx={{ color: 'success.main' }} />{' '}
        <Text variant="subtitle1" fontWeight="600" fontSize="18px">
          {t('Över 50000 nöjda företag och privatpersoner')}
        </Text>
      </li>
      <li css={liCss}>
        <CheckCircleIcon sx={{ color: 'success.main' }} />{' '}
        <Text variant="subtitle1" fontWeight="600" fontSize="18px">
          {t('Automatiskt, säkert och GDPR-kompatibelt')}
        </Text>
      </li>
    </ul>
  );
}

function Logos({ t }) {
  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        flex-basis: 800px;
        margin: auto;
        margin-top: 4.5rem;
        max-width: 1040px;
      `}
    >
      <Text
        variant="subtitle1"
        fontWeight="600"
        fontSize="18px"
        textAlign="center"
        color="text.secondary"
      >
        {t('Kunder som redan effektiviserat sitt arbetsflöde')}
      </Text>
      <div
        css={css`
          display: flex;
          justify-content: space-around;
          padding: 1.5rem;
        `}
      >
        <img src="/logos/blendow_logo_black.svg" alt="Blendow" />
        <img
          src="/logos/shof_logo_black_square.svg"
          alt="Stockholm School of Economics"
        />
        <img src="/logos/hbg_logo_black.svg" alt="Helsingborgs stad" />
        <img src="/logos/delphi_logo_black.svg" alt="Delphi" />
      </div>
    </div>
  );
}

const Signup = () => {
  const { t } = useTranslation();
  const { isMobile } = useIsMobile();
  const [token] = useStore(TOKEN);
  const [isGuest, setIsGuest] = useStore(GUEST);

  const { token: referralToken = '' } = useParams();

  if (token && !isGuest) {
    return <Navigate to="/" />;
  }

  if (IS_SINGLE_TENENT_MODE) {
    return <Navigate to="/login" />;
  }

  return (
    <Skeleton
      publicPage
      title={t('Klang.ai | Skapa konto')}
      showLanguageSelector={false}
      showSignupLinks
    >
      <div
        css={css`
          display: flex;
          padding-top: ${isMobile ? '0px' : '164px'};
          flex-direction: ${isMobile ? 'column' : 'row'};
          max-width: ${isMobile ? '100%' : '1040px'};
          margin: auto;
          justify-content: space-between;
        `}
      >
        <div
          css={css`
            flex-basis: ${isMobile ? '140px' : '410px'};
            display: flex;
            gap: 24px;
            flex-direction: column;
            margin-top: 2.5rem;
          `}
        >
          <Text
            variant="h4"
            fontWeight="700"
            textAlign={isMobile ? 'center' : 'left'}
          >
            {t('Transkribera, planera och analysera intervjuer med AI.')}
          </Text>
          {!isMobile ? <CheckList t={t} /> : null}
        </div>
        <SignupForm referralToken={referralToken} />
      </div>
      {!isMobile ? <Logos t={t} /> : null}
    </Skeleton>
  );
};

export default Signup;
